<template>
  <div class="body">
    <div class="main">
      <div class="title">
        {{ title }}
      </div>
      <div class="from">
        <span>来源:</span><span>{{ from }}</span><span>{{ time }}</span>
      </div>

      <div class="content">
        <div class="content-text">
          <div class="text-1">
            11月9日，紫金保险获得中国银保监会江苏监管局《关于紫金财产保险股份有限公司变更注册资本的批复》，公司增资扩股方案正式获得批准，注册资本金从25亿元人民币增加至60亿元人民币，行业排名第十一位，标志着公司增资扩股工作取得决定性成果。此次增资后，江苏省国信集团有限公司与云南合和（集团）股份有限公司将并列成为公司第一大股东，公司通过引入江苏金财投资有限公司、南京市建邺区高新科技投资集团有限公司等七家新老投资方，进一步提升了公司承保水平、风险防范和市场竞争能力。
          </div>
          <p class="text-img">
            <img :src="text_img01" alt="">
          </p>

          <hr>
          <div class="text-1">
            <p>
              两年艰辛、一朝玉成！此次增资扩股工作，在江苏省委、省政府，银保监会和广大股东的大力支持和指导下顺利完成。下一步，公司将从四个方面抓好落实。<strong
                style="box-sizing: border-box"
              >一是强化战略引领。</strong>以“1248”战略统领发展，在结构优化上下功夫，在科技创新上求突破，在破除体制机制障碍上找出路，扎牢高质量发展基础和提升服务“两高”能力水平。<strong
                style="box-sizing: border-box"
              >二是加强公司治理。</strong>完善公司治理结构，加强“三会一层”建设。增强股东协同和资源互补，实现互利共赢。<strong
                style="box-sizing: border-box"
              >三是着力做优主营。</strong>加快设立保险资管公司。加快在保险产业链上下游投资布局。加强对有合作潜力的金融高科技公司投资。<strong
                style="box-sizing: border-box"
              >四是聚焦贡献价值。</strong>坚持以客户为中心，提供更优质的服务和保障。在员工价值方面、股东价值方面、社会价值方面，通过做强、做大、做优，分更多利润、缴更多税收、创更多就业。
            </p>
          </div>
          <p class="text-img">
            <img :src="text_img02" alt="">
          </p>
          <hr>

          <div class="text-1">
            <p>
              未来公司将继续在“1248”战略的指引下持续发展，向高估值、高价值的金融保险科技公司的目标迈进，为服务地方高质量发展和人民高品质生活做出更大贡献。
            </p>
          </div>
          <p class="text-img3">
            <img :src="text_img03" alt="">
          </p>
          <hr>
          <div class="time_show">
            <div class="time_show01">
              <div class="time_show01_title">
                <p>01</p>
                <p>2009年5月18日</p>
              </div>
              <div class="time_show01_text">
                <div class="time_show1_textbg">
                  <p>
                    公司在江苏南京举办开业典礼，时任省委常委、常务副省长赵克志主持，省委书记梁保华、省长罗志军和保监会副主席周延礼一同为开业揭牌。
                  </p>
                </div>
              </div>
            </div>
            <div class="time_show01">
              <div class="time_show01_title">
                <p>02</p>
                <p>2011年4月</p>
              </div>
              <div class="time_show01_text">
                <div class="time_show1_textbg">
                  <p>公司完成首轮增资扩股，资本金增至25亿元人民币。</p>
                </div>
              </div>
            </div>
            <div class="time_show01">
              <div class="time_show01_title">
                <p>03</p>
                <p>2018年8月7日</p>
              </div>
              <div class="time_show01_text">
                <div class="time_show1_textbg">
                  <p>
                    吴政隆省长和时任分管王江副省长在公司向省政府递交的《关于进一步深化改革推动公司高质量发展的请示》上批示支持公司通过增资扩股实现高质量发展。
                  </p>
                </div>
              </div>
            </div>
            <div class="time_show01">
              <div class="time_show01_title">
                <p>04</p>
                <p>2019年12月4日</p>
              </div>
              <div class="time_show01_text">
                <div class="time_show1_textbg">
                  <p>
                    吴政隆省长主持召开省长办公会议，审议并原则同意省财政厅上报的关于公司增资扩股方案，并对紫金保险提出了“服务地方高质量发展和人民高品质生活”的要求。
                  </p>
                </div>
              </div>
            </div>
            <div class="time_show01">
              <div class="time_show01_title">
                <p>05</p>
                <p>2020年8月12日</p>
              </div>
              <div class="time_show01_text">
                <div class="time_show1_textbg">
                  <p>
                    公司在与政府、监管、主管单位和股东的沟通基础上，举办增资扩股签约仪式，江苏省副省长马欣受邀出席，并对增资扩股工作表示支持。
                  </p>
                </div>
              </div>
            </div>
            <div class="time_show01">
              <div class="time_show01_title">
                <p>06</p>
                <p>2020年11月</p>
              </div>
              <div class="time_show01_text">
                <div class="time_show1_textbg">
                  <p>
                    中国银保监会江苏监管局批复紫金保险增资方案，公司注册资本从25亿元人民币增加至60亿元人民币。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="end-gif">
          <img :src="endPic" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api/api.js'
export default {
  data() {
    return {
      title: '紫金保险增资申请获批，注册资本金增至60亿元',
      from: '原创',
      time: '2020-05-19  15:46',
      text_img01: api.imgAllUrl + '/Allow_img01.jpg',
      text_img02: api.imgAllUrl + '/Allow_img02.jpg',
      text_img03: api.imgAllUrl + '/Allow_img03.jpg',
      endPic: api.imgAllUrl + '/more_end.gif'
    }
  }
}
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
.body {
  width: 100%;
  min-height: 6rem;
  margin-bottom: 0.2rem;
  background: white;
  .main {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 0.1rem;
    .title {
      width: 100%;
      min-height: 0.4rem;
      font-size: 0.2rem;
      line-height: 0.3rem;
      color: #333333;
      opacity: 1;
    }
    .from {
      width: 100%;
      height: 0.22rem;
      font-size: 0.15rem;
      span:nth-child(1) {
        font-size: 0.15rem;
        font-weight: 400;
        line-height: 0.25rem;
        color: #999999;
        opacity: 1;
      }
      span:nth-child(2) {
        font-size: 0.15rem;
        font-weight: 400;
        line-height: 0.25rem;
        color: #815dc4;
        opacity: 1;
        margin-left: 0.1rem;
      }
      span:nth-child(3) {
        font-size: 0.15rem;
        font-weight: 400;
        line-height: 0.25rem;
        color: #999999;
        opacity: 1;
        margin-left: 0.15rem;
      }
    }
    .content {
      margin-top: 0.4rem;
      width: 100%;
      height: 100%;
      .time_show {
        margin-top: 0.5rem;
        width: 100%;
        min-height: 2rem;

        .time_show01 {
          width: 100%;
          min-height: 1rem;

          .time_show01_title {
            width: 50%;
            height: fit-content;
            font-size: 0.15rem;
            border-top: 1px solid black;
            display: flex;
            p:nth-child(1) {
              width: 0.3rem;
              height: 0.3rem;
              background: rgb(92, 107, 192);
              color: #fff;
              text-align: center;
              line-height: 0.3rem;
            }
            p:nth-child(2) {
              flex: 1;
              margin-left: 0.1rem;
              line-height: 0.3rem;
              color: rgb(92, 107, 192);
              font-weight: bolder;
            }
          }
          .time_show01_text {
            width: 100%;
            min-height: 1.06rem;
            font-size: 0.14rem;
            border-left: 1px solid rgb(159, 168, 218);
            box-sizing: border-box;
            padding: 0.1rem;
            .time_show1_textbg {
              width: 100%;
              height: 100%;
              background: rgb(232, 234, 246);
              p {
                width: 100%;
                height: 100%;
                color: rgb(57, 69, 139);
                letter-spacing: 2;
                line-height: 2;
                padding: 0.1rem;
                text-indent: 2em;
                white-space: normal;
                box-sizing: border-box;
              }
            }
          }
        }
      }
      .content-text {
        width: 100%;
        min-height: 4rem;
        background-color: rgba(166, 91, 203, 0.09);
        box-sizing: border-box;
        padding-top: 0.1rem;
        padding-bottom: 0.1rem;
        padding-left: 0.15rem;
        padding-right: 0.15rem;

        .text-1 {
          margin-top: 0.2rem;
          margin-bottom: 0.2rem;
          width: 100%;
          min-height: 0.36rem;
          text-indent: 2em;
          font-size: 0.14rem;
          color: rgb(25, 61, 122);
          text-align: justify;
          letter-spacing: 2px;
          line-height: 2;
        }
        .text-img {
          width: 100%;
          height: 2.5rem;
          border: 1px solid purple;
          background: white;
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            width: 3rem;
            height: 2rem;
          }
        }
        .text-img3 {
          width: 100%;
          min-height: 2.5rem;
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            width: 100%;
            height: 3.5rem;
          }
        }
        hr {
          width: 100%;
          margin-top: 0.2rem;
          color: purple;
        }
      }
      .content-img {
        width: 100%;
        height: 100%;
        padding: 0.05rem;
        box-sizing: border-box;
        img {
          width: 100%;
          height: 100%;
          display: block;
        }
      }
    }
    .end-gif {
      margin-top: 0.2rem;
      width: 100%;
      height: 1.5rem;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/More/More.vue